import * as React from 'react';

import { HomeOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { useLocation, Link } from 'react-router-dom';

import { useMenuInfo } from 'constants/CustomHooks/useMenuInfo';

import CustomeMenu from './CustomeMenu';

type Props = {
    selectedKey: string
}

const LeftSideMenu: React.FC<Props> = props => {
    const location = useLocation();
    const menuInfo = useMenuInfo();
    const [, rootPath] = location.pathname.match(/^(\/(\w|-)+)/) ?? [];
    const [, selectedKey] = props.selectedKey.match(/^(\/(\w|-)+)/) ?? [];

    return (
        <CustomeMenu
            defaultSelectedKeys={[rootPath ?? '/']}
            loading={menuInfo.isLoading}
            mode='inline'
            selectedKeys={[selectedKey ?? '/']}
            theme='dark'
        >
            <Menu.Item icon={<HomeOutlined />} key='/'>
                <Link to='/'>トップ</Link>
            </Menu.Item>

            {menuInfo.items.map(item => (
                <Menu.Item
                    icon={item.iconOfMenu}
                    key={item.url}
                >
                    {item.isOpenNewTab ? (
                        <a href={item.url} target='_blank' rel='noopener noreferrer'>
                            {item.title}
                        </a>
                    ) : (
                        <Link to={item.url}>{item.title}</Link>
                    )}
                </Menu.Item>
            ))}
        </CustomeMenu>
    );
};

export default LeftSideMenu;